import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api, { API } from "../lib/api";
import { PenLine, ShieldCheck, Gift } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const googleLogin = (mode) => {
  if (mode === "oauth") {
    // Self-host: your own Google OAuth client on your VPS.
    window.location.href = `${API}/auth/google/login`;
    return;
  }
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Login() {
  const [googleMode, setGoogleMode] = useState("emergent");

  useEffect(() => {
    api.get("/config").then(({ data }) => setGoogleMode(data.google_mode || "emergent")).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFDF9]">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-[#2D6A4F] text-white">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-lg bg-white/15 flex items-center justify-center"><PenLine className="w-5 h-5" /></div>
          <span className="font-display text-2xl">MainsMentor</span>
        </Link>
        <div>
          <h2 className="font-display text-4xl leading-tight tracking-tight">Your personal answer-writing mentor.</h2>
          <p className="mt-4 text-white/80 max-w-md">Sign in to upload answers, track your scores and watch your marks climb.</p>
          <div className="mt-6 inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 text-sm">
            <Gift className="w-4 h-4 text-[#F0C3AF]" /> 1 free evaluation on your first sign-in
          </div>
        </div>
        <span className="text-white/50 text-sm">Trusted by aspirants preparing for UPSC & State PSC.</span>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md">
          <h1 className="font-display text-3xl tracking-tight">Sign in to MainsMentor</h1>
          <p className="text-[#525252] mt-2">Continue with your Google account — no password to remember.</p>

          <button
            data-testid="google-login-btn"
            onClick={() => googleLogin(googleMode)}
            className="mt-8 w-full flex items-center justify-center gap-3 h-12 rounded-full border border-[#E5E5E5] bg-white hover:bg-[#F7F7F2] transition-colors font-medium"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" />
            Continue with Google
          </button>

          <div className="mt-6 flex items-start gap-2 text-sm text-[#525252]">
            <ShieldCheck className="w-4 h-4 text-[#2D6A4F] mt-0.5 shrink-0" />
            <span>We only use Google to verify it's really you. Your first sign-in unlocks 1 free evaluation.</span>
          </div>

          <p className="mt-8 text-xs text-[#9A9A9A] text-center">
            By continuing you agree to use MainsMentor for personal exam preparation.
          </p>
        </div>
      </div>
    </div>
  );
}
